import { render, staticRenderFns } from "./m-search.vue?vue&type=template&id=afc4ab68&scoped=true&"
import script from "./m-search.vue?vue&type=script&lang=js&"
export * from "./m-search.vue?vue&type=script&lang=js&"
import style0 from "./m-search.vue?vue&type=style&index=0&id=afc4ab68&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afc4ab68",
  null
  
)

export default component.exports